import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { ApiConstants } from "../enum/ApiConstants";
/**
 * ChanceGameParamsData.ts
 */
export class ChanceGameParamsData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.multiplier = Number(this.data.getNumber(ApiConstants.PROPERTY_MULTIPLIER));
            this.type = ChanceGameWinTypeName.indexOf(this.data.getString(ApiConstants.PROPERTY_TYPE));
        }
    }
    getMultiplier() {
        return this.multiplier;
    }
    getType() {
        return this.type;
    }
}
/**
 * ChanceGameConfigData
 */
export class ChanceGameConfigData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.id = this.data.getString(SlingoConstants.PROPERTY_ID) || "";
            this.multiplier = this.data.getNumber(SlingoConstants.PROPERTY_MULTIPLIER) || 1;
        }
    }
    getId() {
        return this.id;
    }
    getMultiplier() {
        return this.multiplier;
    }
}
/**
 * ChanceGameData.ts
 */
export class ChanceGameData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.id = this.data.getNumber(ApiConstants.PROPERTY_ID) || -1;
            this.solidifyChanceGameConfig();
            this.stake = this.data.getNumber(ApiConstants.PROPERTY_STAKE) || 0;
            this.totalWin = this.data.getNumber(ApiConstants.PROPERTY_TOTAL_WIN) || 0;
            this.currencyCode = this.data.getString(ApiConstants.PROPERTY_CURRENCY);
            this.solidifyParams();
        }
    }
    solidifyChanceGameConfig() {
        let gameConfigData = this.data.getDataObject(ApiConstants.PROPERTY_GAME_CONFIG);
        if (this.dataExists(gameConfigData)) {
            this.gameConfig = new ChanceGameConfigData(gameConfigData);
        }
    }
    solidifyParams() {
        let paramsData = this.data.getDataObject(ApiConstants.PROPERTY_PARAMS);
        if (this.dataExists(paramsData)) {
            this.params = new ChanceGameParamsData(paramsData);
        }
    }
    getId() {
        return this.id;
    }
    getGameConfig() {
        return this.gameConfig;
    }
    getPayout() {
        return this.payout;
    }
    getStake() {
        return this.stake;
    }
    getTotalWin() {
        return this.totalWin;
    }
    getCurrencyCode() {
        return this.currencyCode;
    }
    getParams() {
        return this.params;
    }
}
export const ChanceGameWinTypeName = ["cash", "mini", "minor", "major"];
//# sourceMappingURL=ChanceGameData.js.map